export enum Article {
  Art27 = 27,
  Art30 = 30,
}

export const ArticleOptions: Article[] = [Article.Art27, Article.Art30];

export const ArticleString = {
  [Article.Art27]: 'Art. 27',
  [Article.Art30]: 'Art. 30',
};
